import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import LoadingIconButton from 'shared/components/LoadingIconButton/index'

export default class BriefingToolbar extends PureComponent {

    titlePrintProducts = 'Display merged products'
    titleDownloadProducts = 'Download zipped products'
    titleDownloadEFF = 'Download electronic flight folder'

    render() {
        const enableProducts = (!(this.props.selectedIds !== undefined && this.props.selectedIds.length > 0))
        return (
            <nav className='row spark-mar-b-1'>
                <div className="col-md-12 spark-text-right">
                    <LoadingIconButton
                        onClick={() => this.props.actions.onDisplayMergeProducts()}
                        icon='spark-icon-documents'
                        loading={this.props.loadingButtons !== undefined ? this.props.loadingButtons.mergeProductsBtn : false}
                        title={this.titlePrintProducts}
                        disabled={enableProducts}/>
                    <LoadingIconButton
                        onClick={() => this.props.actions.onDownloadZipProducts()}
                        icon='spark-icon-document-compress-zip'
                        loading={this.props.loadingButtons !== undefined ? this.props.loadingButtons.zipProductsBtn : false}
                        title={this.titleDownloadProducts}
                        disabled={enableProducts}/>
                    <LoadingIconButton
                        onClick={() => this.props.actions.onDownloadEFF()}
                        icon='spark-icon-file-download'
                        loading={this.props.loadingButtons !== undefined ? this.props.loadingButtons.effBtn : false}
                        title={this.titleDownloadEFF}/>
                </div>
            </nav>
        )
    }
}

BriefingToolbar.propTypes = {
    loadingButtons: PropTypes.object,
    selectedIds: PropTypes.array,
    actions: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/screens/briefing/products/components/Toolbar.js